import share from './reducers/share';

export default {
    share: {
        reducer: share,
    },
};
